<template>
  <v-div>
  <v-card class="mx-auto">
    <v-row class="fill-height ma-0">
      <v-col class="pa-0" cols="12">
        <v-avatar class="profile float-left" color="grey" tile min-width="90" height="90">
          <v-img :src="group.user.avatar" width="100%" height="auto"></v-img>
        </v-avatar>
        <v-list-item>
          <v-list-item-content class="mt-n4">
            <v-list-item-title class="text-h6"
              >{{ group.user.name }}</v-list-item-title
            >
            <v-list-item-subtitle>
                {{group.user.company}}
            </v-list-item-subtitle>
            <p>{{ group.user.mood }}</p>
            <p>{{ group.user.email }}</p>
          </v-list-item-content>
        </v-list-item>        
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-card-text>
      <v-list-item-content>
        <v-row>
          <v-col cols="6" md="6" class="py-1">
            {{ $t(page+'.Credit Limit') +': '}}
          </v-col>
          <v-col cols="6" md="6" class="py-1">
            {{group.user.plafond}}
          </v-col>
          <v-col cols="6" md="6" class="py-1">
            {{ $t(page+'.CaaS') +': '}}
          </v-col>
          <v-col cols="6" md="6" class="py-1">
            {{group.user.caas?'SI':'NO'}}
          </v-col>                                                  
        </v-row>
      </v-list-item-content>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text v-if="group.conversations.fullName!==undefined">
      <v-list-item-title class="mt-2">
        {{$t(page+'.Shipment')}}:
      </v-list-item-title>
      <v-list-item-content>
        <v-row class="mt-2">
          <v-col cols="6" md="2" class="pt-3">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  fas fa-user
                </v-icon>
              </template>
              <span>{{ $t(page+'.Full Name')}}</span>
            </v-tooltip>            
          </v-col>
          <v-col cols="6" md="10" class="pt-3">
            {{group.conversations.fullName}}
          </v-col> 
          <v-col cols="6" md="2" class="pt-3">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  fas fa-map-marked
                </v-icon>
              </template>
              <span>{{ $t(page+'.Address')}}</span>
            </v-tooltip> 
          </v-col>
          <v-col cols="6" md="10" class="pt-3">
            {{group.conversations.addressLine1}}
          </v-col> 
          <v-col cols="6" md="2" class="pt-3">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  fas fa-city
                </v-icon>
              </template>
              <span>{{ $t(page+'.City')}}</span>
            </v-tooltip> 
          </v-col>
          <v-col cols="6" md="10" class="pt-3">
            {{group.conversations.city + '  -  ' + group.conversations.stateOrProvince }} 
          </v-col> 
          <v-col cols="6" md="2" class="pt-3">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  fas fa-barcode
                </v-icon>
              </template>
              <span>{{ $t(page+'.Tracking ID')}}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="10" class="pt-3">
            {{group.conversations.trackingId}}
          </v-col>
          <v-col cols="6" md="2" class="pt-3">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  fas fa-hand-holding-usd
                </v-icon>
              </template>
              <span>{{ $t(page+'.COD Amount')}}</span>
            </v-tooltip>             
          </v-col>
          <v-col cols="6" md="10" class="pt-3">
            {{group.conversations.CODAmount}}
          </v-col> 
          <v-col cols="6" md="2" class="pt-3">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  fas fa-question-circle
                </v-icon>
              </template>
              <span>{{ $t(page+'.Status')}}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="10" class="pt-3">
            {{group.conversations.orderStatus}}
          </v-col>
          <v-col cols="6" md="2" class="pt-3">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  fas fa-clock
                </v-icon>
              </template>
              <span>{{ $t(page+'.Status Time')}}</span>
            </v-tooltip>             
          </v-col>
          <v-col cols="6" md="10" class="pt-3">
            {{group.conversations.orderStatusTime}}
          </v-col>
          <v-col cols="6" md="2" class="pt-3">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  fas fa-truck-loading
                </v-icon>
              </template>
              <span>{{ $t(page+'.Shipped')}}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="10" class="pt-3">
            {{group.conversations.MANIFESTEDStatusTime}}
          </v-col>
          <v-col cols="6" md="2" class="pt-3">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  fas fa-people-carry
                </v-icon>
              </template>
              <span>{{ $t(page+'.Delivered')}}</span>
            </v-tooltip> 
          </v-col>
          <v-col cols="6" md="10" class="pt-3">
            {{group.conversations.DELIVEREDStatusTime}}
          </v-col>
          <v-col cols="6" md="2" class="pt-3">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  fas fa-file-pdf
                </v-icon>
              </template>
              <span>{{ $t(page+'.PDF Label')}}</span>
            </v-tooltip>             
          </v-col>
          <v-col cols="6" md="10" class="pt-3">
            <v-btn v-if="group.conversations.fullName!==undefined" @click="showPDF()" x-small color="success" >Label</v-btn>
          </v-col>
          <v-col cols="6" md="2" class="pt-3">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  fas fa-satellite-dish
                </v-icon>
              </template>
              <span>{{ $t(page+'.Live Tracking')}}</span>
            </v-tooltip>             
          </v-col>
          <v-col cols="6" md="10" class="pt-3">
            <v-btn v-if="group.conversations.fullName!==undefined" @click="openCarrierWindow()" x-small color="info" >Tracking</v-btn>
          </v-col>           
        </v-row>
      </v-list-item-content>
    </v-card-text>    
  </v-card>
  <v-dialog v-model="showPDF_dialog" max-width="800">
    <v-card>
      <v-card-title class="text-h5">
        AWB
      </v-card-title>
      <v-card-text>
        <iframe id="ifrm" :src="showPDF_url" width="100%" min-height="600px" height="100%"></iframe>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn dark color="primary" @click="showPDF_dialog = false">
          {{$t(page+'.Close')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
<!--
  <v-dialog eager v-model="showPDF_dialog" hide-overlay open-delay="50" scrollable="true" transition="dialog-bottom-transition">
    <v-card heigth="100%">
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="showPDF_dialog = false"
        >
          <v-icon>fas fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>PDF</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            darkS
            text
            @click="showPDF_dialog = false"
          >
            Close
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>       
      </v-card>
    </v-dialog> -->
  </v-div> 
</template>

<script>
export default {
  props: {
    drawer: Boolean,
    group: Object,
    onToggleDrawer: Function,
  },
  data() {
    return {
      page:'BossTickets',
      userDetailMenu: false,
      showPDF_dialog:false,
      showPDF_url:null
    };
  },
  methods:
  {
    showPDF()
    {
        console.log(165, this.group.conversations);
        this.showPDF_url='/docs/'+this.group.conversations.path+'_PDF/'+this.group.conversations.trackingId+'_01_'+this.group.conversations.sid+'.pdf';
        this.showPDF_dialog=true;
    },
    async openCarrierWindow()
    {
      console.log(171, this.group.conversations);
      var url=this.group.conversations.liveTrackingURL;
      if (this.eBayWindow == null || this.eBayWindow.closed)
      {
        const w=900;
        const h=600;
        const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

        const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        const systemZoom = width / window.screen.availWidth;
        const left = (width - w) / 2 / systemZoom + dualScreenLeft
        const top = (height - h) / 2 / systemZoom + dualScreenTop+20

        var eb_options = `width=${w}, height=${h}, top=${top}, left=${left}`;//'height=550,width=800,left=400,top=100';
        this.disabled=false;
        this.loading=false;
        console.log('eb_options',eb_options,url);
        this.eBayWindow = window.open(url,"Live Tracking", eb_options);
      }
      else
      {
        this.eBayWindow.close();
      }     
    },  
  }
};
</script>
